import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Equipe} from '../models/equipe';


const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/pointage';

@Injectable()
export class PointageService {

  constructor(private http: HttpClient) { }

  findByPage(p: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('page', String(p)).set('pageSize', String(size));
    const url = `${apiUrl}/findByPage`;
    return this.http.get<any>(url, {params});
  }

  findByMois(mois: number, annee: number, p: number, size: number): Observable<any> {
    const params = new HttpParams()
        .set('mois', String(mois))
        .set('annee', String(annee))
        .set('page', String(p))
        .set('pageSize', String(size));
    const url = `${apiUrl}/findByMois`;
    return this.http.get<any>(url, {params});
  }

  getById(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.get<any>(url);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<any>(url, httpOptions);
  }

  create(pointage: any) {
    return this.http.post<Equipe>(apiUrl + '/save', pointage, httpOptions);
  }

  update(id, pointage: any) {
    const url = `${apiUrl}/${id}`;
    return this.http.post(apiUrl + '/save', pointage, httpOptions);
  }

  findByIds(ids: number[]): Observable<any> {
    const params = new HttpParams()
        .set('ids', String(ids));
    const url = `${apiUrl}/findByIds`;
    return this.http.get<any>(url,{params});
  }

  recap(): Observable<any> {
    const url = `${apiUrl}/recap`;
    return this.http.get<any>(url);
  }

  export(mois: number, annee: number): Observable<any> {
    let params = new HttpParams().set('mois', String(mois)).set('annee', String(annee));
    return this.http.get(`${apiUrl}/export/excel`, {
      params: params,
      responseType: 'blob'
    });
  }

  exportPointageparMois(mois: number, annee: number): Observable<any> {
    let params = new HttpParams().set('mois', String(mois)).set('annee', String(annee));
    return this.http.get(`${apiUrl}/export/excel-pointagepar-mois`, {
      params: params,
      responseType: 'blob'
    });
  }

  exportPointageparJour(jour: string): Observable<any> {
    let params = new HttpParams().set('jour', String(jour));
    return this.http.get(`${apiUrl}/export/excel-pointagepar-jour`, {
      params: params,
      responseType: 'blob'
    });
  }

}
